import {
    Announcement02,
    Award03,
    HomeLine,
    LineChartUp02,
    Link03,
    ShoppingCart01,
    Star06,
    Stars02,
    Wallet02,
    Code02,
    Hash02,
    Ticket02,
} from "@untitledui/icons";
import type { NavItemDividerType, NavItemType } from "@mfa-aff/ui";
import { winningBadge } from "./components/WinningCard";

/**
 * Partner panel navigation (spec §11), in three plain groups so a partner finds things by what
 * they want to do: sell, see their earnings, grow. «سفیر» joins the last group when it is on.
 */
export const partnerNav: (NavItemType | NavItemDividerType)[] = [
    { label: "خانه", href: "/", icon: HomeLine },
    { divider: true, label: "فروش" },
    { label: "بازاریابی با کد تخفیف", href: "/codes", icon: Ticket02, badge: winningBadge },
    { label: "بازاریابی با لینک", href: "/links", icon: Link03 },
    { label: "بازاریابی با کد معرف", href: "/refcode", icon: Hash02 },
    { label: "سفارش‌ها", href: "/orders", icon: ShoppingCart01 },
    { label: "کیت بازاریابی", href: "/kit", icon: Announcement02 },
    { label: "افزونهٔ وردپرس", href: "/wordpress", icon: Code02 },
    { divider: true, label: "درآمد شما" },
    { label: "درآمد", href: "/earnings", icon: LineChartUp02 },
    { label: "موجودی و برداشت", href: "/wallet", icon: Wallet02 },
    { divider: true, label: "رشد" },
    { label: "سطح‌ها و هدیه‌ها", href: "/levels", icon: Award03 },
    { label: "همکاری ویژه", href: "/special", icon: Stars02 },
];

/** Only shown when the ambassador flag is on for this partner (spec §14.5). */
export const ambassadorNavItem: NavItemType = { label: "سفیر", href: "/ambassador", icon: Star06 };

/** Help and account links, shown in the page footer (not the sidebar, which must fit without scrolling). */
export const partnerFooterLinks: { label: string; href: string }[] = [
    { label: "چطور کار می‌کند", href: "/how-it-works" },
    { label: "واژه‌نامه", href: "/glossary" },
    { label: "قوانین", href: "/rules" },
    { label: "حساب", href: "/account" },
];
